import styles from './Artwork.module.scss';
import { MouseEventHandler } from 'react';
import GridLoader from '../GridLoader/GridLoader';


interface ArtworkProps {
  size : number;
  imageURL : string;
  id : number;
  type : string;
  onClick? : MouseEventHandler<HTMLDivElement>;
  className? : string;
  isLoading? : boolean;
}

const Artwork = (props : ArtworkProps) => {
  const cursor = { cursor: props.onClick ? 'pointer' : 'default' };

  return (
    <div className={styles.ArtworkContainer +' '+ props.className} style={{ width: props.size, height: props.size, maxWidth: props.size}} data-testid={props.type}>
      <div className={styles.Artwork} style={cursor} onClick={props.onClick}>
        {props.isLoading ? (
          <div className={styles.LoadingContainer} style={{ width: props.size, height: props.size, maxWidth: props.size}}>
            <GridLoader />
          </div>
        ) : (
          <img src={props.imageURL} alt={props.type} />
        )}
      </div>
      <div className={styles.Footer}>
        <span>{props.type}</span>
        <span>#{props.id}</span>
      </div>
    </div> 
  )
};

export default Artwork;